import { Box, Button, Text, Title } from '@holbonkit/ui'

import styles from './processing.module.scss'

import { IllustrationProcessing } from '@/assets'

export const Processing = () => {
    return (
        <Box className={styles['processing']} pb={4} px={4}>
            <img
                alt='processing'
                className={styles['processing__illustration']}
                src={IllustrationProcessing}
            />
            <Box className={styles.content}>
                <Title variant='header-24-bold'>Анкета в обработке</Title>
                <Box className={styles['content__description']}>
                    <Text
                        as='p'
                        className={styles['content__description--secondary']}
                        variant='body-m-16-regular'
                    >
                        Проверка анкеты обычно занимает не больше пяти минут
                    </Text>
                </Box>
            </Box>
            <Button
                fullWidth
                className={styles['processing__button']}
                size='lg'
                variant='primary'
                onClick={() => {
                    console.log('processing')
                }}
            >
                Хорошо
            </Button>
        </Box>
    )
}
